module.exports = __webpack_public_path__ + "img/infranepal.22d1dd8f.png";